import { useCallback, useRef } from 'react';

import { UnknownErrorModal } from '../../components/common/unknown-error-modal';

export function useUnknownErrorModal(showModal: (component: React.ComponentType<any>, props: any) => void) {
  const modalShownRef = useRef(false);

  return useCallback((): void => {
    if (modalShownRef.current) return;
    modalShownRef.current = true;

    showModal(UnknownErrorModal, {
      onClose: () => {
        modalShownRef.current = false;
      },
    });
  }, [showModal]);
}
